var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { tabbable } from 'tabbable';
import { FlipperWrapper } from './subcomponents';
var Flipper = function (_a) {
    var shouldFlipContent = _a.shouldFlipContent, frontContent = _a.frontContent, backContent = _a.backContent, focusFirstElement = _a.focusFirstElement, focusCustomElement = _a.focusCustomElement;
    var refOuter = useRef(null);
    var hasRendered = useRef(false);
    var _b = useState(false), shouldAnimate = _b[0], setShouldAnimate = _b[1];
    useEffect(function () {
        hasRendered.current || (hasRendered.current = shouldFlipContent);
        if (hasRendered.current) {
            setShouldAnimate(true);
        }
        // focus first element
        if (refOuter.current) {
            if (focusCustomElement === null || focusCustomElement === void 0 ? void 0 : focusCustomElement.current) {
                focusCustomElement.current.focus();
            }
            else if (focusFirstElement) {
                var firstElement = tabbable(refOuter.current)[0];
                firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
            }
        }
    }, [shouldFlipContent, focusFirstElement, focusCustomElement]);
    /*
     * Once the animation has ended we set it to false. That way when it changes back to True
     * it will animate. See useEffect above
     */
    var onAnimationEndCaptureHandle = function () {
        setShouldAnimate(false);
    };
    return (_jsx(FlipperWrapper, __assign({ shouldAnimate: shouldAnimate, onAnimationEndCapture: onAnimationEndCaptureHandle, "data-test": "FlipperWrapper", ref: refOuter }, { children: !shouldFlipContent ? frontContent : backContent })));
};
export default React.memo(Flipper);
